import { Button, SimpleTable, Input } from "@components";
import { Search } from "react-bootstrap-icons";

const tableConfig = {
  columns: [
    {
      title: "Account",
      key: "accountCode",
      width: "80px",
      render: (x) => x.accountCode,
    },
    {
      title: "Name",
      key: "name",
      render: (x) => x.name,
    },
  ],
};

export function AccountSelectionStep({
  loading,
  saving,
  selectingAll,
  searchTerm,
  onSearchChange,
  accounts,
  selectedCount,
  isEditMode,
  isRowSelected,
  onToggleRow,
  onBack,
  onSave,
  onLoadMore,
  hasMoreData,
  totalRows,
  searchResultCount,
  onSelectAll,
  onDeselectAll,
}) {
  return (
    <div className="flex flex-col h-[500px]">
      <div className="px-5 pt-4 pb-2">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 size-4 z-10" />
          <Input
            type="text"
            placeholder="Search accounts..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9"
            disabled={saving}
          />
        </div>
      </div>
      <div className="flex-1 overflow-auto mx-5">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-zinc-500">Loading accounts...</p>
          </div>
        ) : (
          <SimpleTable
            config={tableConfig}
            data={accounts}
            noFooter
            lazyLoad
            isRowSelected={isRowSelected}
            onToggleRow={onToggleRow}
            onLoadMore={onLoadMore}
            hasMoreData={hasMoreData}
            totalRows={totalRows}
            totalSelectedRows={selectedCount}
            displayedRows={searchResultCount}
            onSelectAll={onSelectAll}
            onDeselectAll={onDeselectAll}
            selectionDisabled={saving || selectingAll}
            selectionLoading={selectingAll}
            searchTerm={searchTerm}
          />
        )}
      </div>
      <div className="flex gap-2 p-5 border-t border-zinc-200">
        <Button
          type="button"
          className="shrink-0 rounded-lg"
          onClick={onBack}
          disabled={saving}
        >
          Back
        </Button>
        <Button
          type="button"
          color="primary"
          className="shrink-0 grow rounded-lg"
          onClick={onSave}
          disabled={loading || selectedCount < 1}
          submitting={saving}
        >
          {isEditMode
            ? `Save group (${selectedCount} accounts)`
            : `Create group (${selectedCount} accounts)`}
        </Button>
      </div>
    </div>
  );
}
